import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail } from "lucide-react";
import api, { formatError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(formatError(err.response?.data?.detail) || err.message); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#EAF7F4] font-parent text-slate-900 flex items-center justify-center p-5" data-testid="forgot-password-page">
      <div className="nb-card bg-white p-8 w-full max-w-md">
        <h1 className="text-2xl font-bold flex items-center gap-2"><Mail className="text-blue-600" /> Forgot password? / Mot de passe oublié ?</h1>
        {sent ? (
          <p className="mt-4 text-slate-700" data-testid="forgot-password-sent">If an account exists for <b>{email}</b>, we have sent a link to choose a new password. It expires in 1 hour. Check your spam folder too. / Si un compte existe, un lien vous a été envoyé (valable 1 heure).</p>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-3">
            <p className="text-sm text-slate-600">Enter your login email and we will send you a link to choose a new password.</p>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="forgot-password-email"
              className="w-full rounded-xl border-2 border-slate-200 px-3 py-2.5" />
            {error && <p className="text-sm text-red-600" data-testid="forgot-password-error">{error}</p>}
            <button type="submit" disabled={busy} data-testid="forgot-password-submit" className="w-full rounded-full bg-blue-600 text-white font-semibold py-2.5 disabled:opacity-60">
              {busy ? <Loader2 size={16} className="animate-spin mx-auto" /> : "Send me a link / Envoyer le lien"}
            </button>
          </form>
        )}
        <Link to="/login" className="mt-5 inline-block text-sm font-semibold text-blue-600" data-testid="forgot-password-back">← Back to log in</Link>
      </div>
    </div>
  );
}
